addEventListener("load", async () => {
  var bodyContainer = document.querySelector("body");
  var buttonCheckout = document.querySelector(".btn-continue-checkout");
  var GAHelpers = (() => {
    return {
      viewDevice: () => {
        if (navigator.userAgent.match(/(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone)/i) === null) {
          return true;
        }
      },
      /**
       * Get cart json
       * @returns cart
       */
      cartInfo: async () => {
        return await fetch("/cart.js")
          .then((response) => response.json())
          .then((cart) => {
            return cart;
          });
      },
      /**
       *
       * @param {*} handle
       * @param {*} item
       * @returns
       */
      addCategorySellerToProduct: async function (handle, item) {
        const { product } = await GAHelpers.productByHandle(handle);
        const productTags = product.tags.split(",").map((tag) => tag.trim());

        const isMarketPlace = productTags.some((tag) => tag.startsWith("MKP"));

        if (isMarketPlace) {
          item.item_category1 =
            productTags.find((tag) => tag.startsWith("seller_")) ||
            "kitchencenter";
        }

        return item;
      },
      /**
       * 
       * @param {*} price 
       */
      formatPrice: (price) => {
        let priceString = price.toString();
        if (priceString.length >= 7) {
          var integer = priceString.slice(0, -2);
          priceString = integer;
        }
        return priceString
      },
      /**
       * Get product data by handle
       * @param {*} handle String
       * @returns product
       */
      productByHandle: async (handle) => {
        return await fetch(`/products/${handle}.json`)
          .then((response) => response.json())
          .then(async (product) => {
            if (product.product) {
              if (product.product) {
                const productTags = product.product.tags
                  .split(",")
                  .map((item) => item.trim());
                const isMarketPlace = productTags.find((item) =>
                  item.startsWith("MKP")
                );
                product.product.item_category1 = isMarketPlace
                  ? productTags.find((item) => item.startsWith("seller_"))
                  : "kitchencenter";
              }
            }
            return product;
          });
      },
      /**
       * Normalize Product Variant by cart.json
       * @param {*} variants
       * @returns
       */
      normalizeProductVariant: function (variants) {
        if (variants.length > 0) {
          const normalizeProductsArray = [];
          variants.map(async (variant) => {
            const output = {
              item_id: variant.sku,
              item_name: variant.product_title,
              currency: "CLP",
              item_brand: variant.vendor,
              item_category: variant.product_type,
              item_category1: variant?.properties
                ? variant?.properties?.distributed_by
                : variant.item_category1.replace("seller_", ""),
              item_variant: variant.variant_title,
              price: GAHelpers.formatPrice(variant.final_price),
              quantity: variant.quantity,
              index: variant?.index ? variant.index : ""
            };
            normalizeProductsArray.push(output);
          });
          return normalizeProductsArray;
        }
      },
      /**
       * Normalize Current Variant
       * @param {*} product
       * @param {*} variantId
       * @returns
       */
      normalizeCurrentVariant: function (product, variantId = null) {
        if (variantId) {
          var variant = product.variants.filter(
            (x) => x.id === parseInt(variantId)
          )[0];
        } else {
          var variant = product.variants[0];
        }
        return {
          id: variant.sku,
          quantity: 1,
          variant_id: variant.id,
          variant_title: product.title,
          item_category1: product.item_category1.replace("seller_", ""),
          price: GAHelpers.formatPrice(variant.price),
          final_price: GAHelpers.formatPrice(variant.price),
          vendor: product.vendor,
          handle: product.handle,
          product_type: product.product_type,
          product_title: product.title,
          index: product?.index ? product.index : "",
          sku: variant.sku
        };
      },
      /**
       * Get Product Handle By URL
       * @returns
       */
      normalizeProductHandleByURL: function () {
        const url = window.location.pathname;
        const withoutProducts = url.replace("/products/", "");
        const withoutVariant = withoutProducts.replace(
          /(\?|\&)variant=([^&]*)(&|$)/,
          ""
        );
        return withoutVariant.split("?")[0];
      },
      /**
       * Get Colletion and Product handle from URL
       *
       * @param {*} urlString
       * @returns
       */
      normalizeGetDataCollectionFromURL: function (urlString) {
        var url = new URL(urlString, window.location.origin);
        var pathname = url.pathname;
        var collection = pathname.split("/")[2];
        var product = pathname.split("/")[4];
        return {
          collectionHandle: collection,
          collection: collection
            .replace(/-/g, " ")
            .replace(/\b\w/g, function (match) {
              return match.toUpperCase();
            }),
          product,
        };
      },
      /**
       * Event Type: Checkout
       *
       * @param {*} eventName String
       */
      eventProcessCheckout: async function (eventName = null) {
        if (eventName) {
          const cart = await GAHelpers.cartInfo();
          const dataLayer = {
            currency: "CLP",
            value: GAHelpers.formatPrice(cart.total_price),
            items: GAHelpers.normalizeProductVariant(cart.items),
          };
          if (eventName === "add_payment_info") {
            dataLayer.payment_type = "Mercado Pago";
          }
          GAHelpers.dataLayer(dataLayer, eventName);
        }
      },
      /**
       * Event Type: Add To Cart
       * @param {*} eventName2
       */
      eventProduct: async function (eventName = null, variant) {
        if (eventName) {
          const dataLayer = {
            currency: "CLP",
            value: GAHelpers.formatPrice(variant.price),
            items: GAHelpers.normalizeProductVariant([variant]),
          };
          GAHelpers.dataLayer(dataLayer, eventName);
        }
      },
      /**
       *
       * @param {*} eventName
       * @param {*} variant
       * @param {*} collection
       */
      eventCollection: async function (
        eventName = null,
        variant = null,
        products = null,
        collection
      ) {
        if (eventName) {
          const dataLayer = {
            item_list_id: collection.collectionHandle,
            item_list_name: collection.collection,
            items: GAHelpers.normalizeProductVariant(
              !variant ? products : [variant]
            ),
          };
          GAHelpers.dataLayer(dataLayer, eventName);
        }
      },
      /**
       *
       * @param {*} eventName
       */
      eventOrderConfirmation: async function (eventName = null) {
        const cart = await GAHelpers.cartInfo();
        const dataLayer = {
          currency: "CLP",
          transaction_id: window.orderInfo.transaction_id,
          value: cart.total_price,
          shipping: window.orderInfo.shipping_price,
          tax: window.orderInfo.tax_total,
          items: GAHelpers.normalizeProductVariant(cart.items),
        };
        GAHelpers.dataLayer(dataLayer, eventName);
      },
      /**
       * @param {*} eventName
       * @param {*} data
       */
      eventClickPromotions: function (eventName = null, parent = null) {
        const dataLayer = {
          creative_slot: parent?.getAttribute("data-layerid"),
          promotion_id: parent?.getAttribute("data-layer-position"),
          promotion_name: parent?.getAttribute("data-layer-name"),
          creative_name: parent?.getAttribute("data-layercreative"),
        };
        GAHelpers.dataLayer(dataLayer, eventName);
      },
      /**
       *
       * @param {*} eventName
       * @param {*} data
       */
      eventClickContent: function (eventName, dataLayer) {
        GAHelpers.dataLayer(dataLayer, eventName);
      },
      /**
       * Dispatch GA Event
       *
       * @param {*} data Array <object>
       * @param {*} eventName String
       */
      dataLayer: function (data, eventName) {
        if (data && eventName) {
          gtag("event", eventName, data);
          //console.log("===event", eventName, data);
        }
      },
    };
  })();

  /**
   * Events by click
   *
   * @param {*} param0
   */

  if (buttonCheckout) {
    buttonCheckout.addEventListener(
      "click",
      () => {
        GAHelpers.eventProcessCheckout("begin_checkout");
      },
      { once: true }
    );
  }

  bodyContainer.onclick = async ({ target }) => {
    /**
     * Page URL: ALL Site
     * Button Action: Cart drawer button: 'ver carrito'
     */
    if (target.classList.contains("rebuy-button")) {
      GAHelpers.eventProcessCheckout("view_cart");
    }

    /**
     * Rebuy Event: Add
     * Page URL: /products/product-name
     * Button Action: PDP - Add to cart
     */
    document.addEventListener("rebuy:cart.add", async (event) => {
      const product = await GAHelpers.addCategorySellerToProduct(
        event.detail.item.handle,
        event.detail.item
      );
      GAHelpers.eventProduct("add_to_cart", product);
    });

    /**
     * Rebuy Event: Delete
     * Page URL: All Site
     * Button Action: Delete product from rebuy cart
     */
    if (target.classList.contains("rebuy-cart__flyout-item-remove")) {
      const productHandle = target.getAttribute("data-product-handle");
      const { items } = await GAHelpers.cartInfo();
      const product = items.filter((x) => x.handle === productHandle)[0];
      GAHelpers.eventProduct("remove_from_cart", product);
    }

    /**
     * Event click on product collections
     * Page URL: Collections Page
     * Button Action: Click an any product
     */
    if (target.classList.contains("itemLink")) {
      const url = target.getAttribute("href");
      const data = GAHelpers.normalizeGetDataCollectionFromURL(url);
      const { product } = await GAHelpers.productByHandle(data.product);
      const variant = GAHelpers.normalizeCurrentVariant(product);
      GAHelpers.eventCollection("select_item", variant, null, {
        collectionHandle: variant.handle,
        collection: variant.product_title,
      });
    }

    if (target.classList.contains("nav-link")) {
      const data = {
        content_type: "header",
        item_list_name: target.getAttribute("title")
      }
      GAHelpers.eventClickContent("select_content", data)
    }

    if (target.classList.contains("submenu_link")) {
      if (target.getAttribute("data-product")) {
        const data = {
          content_type: "header",
          item_list_name: target.getAttribute("data-product")
        }
        GAHelpers.eventClickContent("select_content", data)
      }
    }

    if (target.classList.contains("subheader__product")) {
      if (target.getAttribute("data-product")) {
        const data = {
          content_type: "header",
          item_list_name: target.getAttribute("data-product")
        }
        GAHelpers.eventClickContent("select_content", data)
      }
    }

    if (target.classList.contains("tab-content-item")) {
      const href = target.querySelector(".link_to");
      const handle = href.getAttribute("data-handle");
      const { product } = await GAHelpers.productByHandle(handle);
      const variant = GAHelpers.normalizeCurrentVariant(product);
      var title = ""
      document.querySelectorAll(".tab-title.ppal").forEach(item => {
        if (item.getAttribute("data-active") === "true") {
          title = item.getAttribute("data-name");
        }
      })

      GAHelpers.eventCollection("select_item", variant, null, {
        collectionHandle: title.toLocaleLowerCase(),
        collection: title,
      });

      window.location.href = href
    }

    /**
     * Event click on search button
     * Page URL: All Site
     * Button Action: Search button
     */
    if (target.classList.contains("input-search")) {
      const data = {
        search_term: document.querySelector("#searchInput").value
      }
      GAHelpers.eventClickContent("search", data)
    }
    if (window.location.pathname === "/") {

      if (target.classList.contains("main__banner--content-cta")) {
        GAHelpers.eventClickPromotions("select_promotion", target.parentNode);
      }
      if (target.classList.contains("banner__info-url")) {
        GAHelpers.eventClickPromotions("select_promotion", target.parentNode);
      }
      if (
        target.classList.contains("timer-discount-cta") ||
        target.classList.contains("timer-discount-img")
      ) {
        GAHelpers.eventClickPromotions(
          "select_promotion",
          target.parentNode.parentNode
        );
      }
      if (target.classList.contains("featrue-banner-desktop")) {
        GAHelpers.eventClickPromotions(
          "select_promotion",
          target.parentNode.parentNode.parentNode
        );
      }

      if (target.classList.contains("header-slider-image")) {
        GAHelpers.eventClickPromotions(
          "select_promotion",
          target.parentNode
        );
      }

      if (target.classList.contains("banner-with-countdown-alternate-1-image")) {
        GAHelpers.eventClickPromotions(
          "select_promotion",
          target.parentNode
        );
      }

      if (target.classList.contains("banner-with-countdown-alternate-1-image-2")) {
        GAHelpers.eventClickPromotions(
          "select_promotion",
          target.parentNode
        );
      }

      if (target.classList.contains("full-banner-countdown-section-image")) {
        GAHelpers.eventClickPromotions(
          "select_promotion",
          target.parentNode
        );
      }

      if (
        target.classList.contains("featrue-banner-title") ||
        target.classList.contains("featrue-banner-subtitle")
      ) {
        GAHelpers.eventClickPromotions(
          "select_promotion",
          target.parentNode.parentNode
        );
      }
      // if (target.classList.contains("shop-category")) {
      //   const data = {
      //     content_type: "categoria",
      //     item_list_name: target.getAttribute("name"),
      //   };
      //   GAHelpers.eventClickContent("select_content", data);
      // }

      if (target.classList.contains("tab-title")) {
        const data = {
          content_type: "category tabs",
          item_list_name: target.getAttribute("data-name")
        }
        GAHelpers.eventClickContent("select_content", data);
      }

      if (target.classList.contains("rebuy-product-image")) {
        const params = new URLSearchParams(target.getAttribute("href"));
        const handle = params.get('_rdiscovery-handle');
        const { product } = await GAHelpers.productByHandle(handle);
        const variant = GAHelpers.normalizeCurrentVariant(product);
        GAHelpers.eventCollection("select_item", variant, null, {
          collectionHandle: "sale",
          collection: "Sale",
        });
      }

      if (target.classList.contains("tab-card-carousel")) {
        const title = target.getAttribute("data-title");
        const data = {
          content_type: "Cocina con nosotros | blog",
          item_list_name: target.getAttribute("data-title")
        }
        GAHelpers.eventClickContent("select_content", data);
      }

      if (target.classList.contains("tab-card-carousel-product")) {
        const handle = target.getAttribute("data-title");
        const { product } = await GAHelpers.productByHandle(handle);
        const variant = GAHelpers.normalizeCurrentVariant(product);
        GAHelpers.eventCollection("select_item", variant, null, {
          collectionHandle: variant.handle,
          collection: variant.product_title,
        });
      }
    }

    if (target.classList.contains('card-product')) {
      const handle = target.getAttribute("data-handle");
      const { product } = await GAHelpers.productByHandle(handle);
      const variant = GAHelpers.normalizeCurrentVariant(product);
      variant.index = target.getAttribute("data-index");
      GAHelpers.eventCollection("select_item", variant, null, {
        collectionHandle: variant.handle,
        collection: variant.product_title,
      });
      window.location.href = `/products/${handle}`;
    }

    if (target.getAttribute('data-coll-url')) {
      const collection = target.getAttribute('data-coll-url');
      const collectionTitle = collection.replace("/collections/", "")
      const data = {
        content_type: `Collection | ${collectionTitle}`,
        item_list_name: collection
      }
      GAHelpers.eventClickContent("select_content", data);
    }

    if (target.classList.contains("banner-image-allternate-linets")) {
      GAHelpers.eventClickPromotions(
        "select_promotion",
        target.parentNode.parentNode.parentNode.parentNode.parentNode
      );
    }

    if (target.classList.contains("cyber-collection-item")) {
      GAHelpers.eventClickPromotions(
        "select_promotion",
        target.parentNode
      );
    }

    if (target.classList.contains("section-image-flash")) {
      GAHelpers.eventClickPromotions(
        "select_promotion",
        target.parentNode
      );
    }

    if (target.classList.contains("section-banner-offer-image")) {
      GAHelpers.eventClickPromotions(
        "select_promotion",
        target.parentNode
      );
    }

    if (target.classList.contains("section-banner-asados-image")) {
      GAHelpers.eventClickPromotions(
        "select_promotion",
        target.parentNode
      );
    }

    if (target.classList.contains("banner-publicidad-image")) {
      GAHelpers.eventClickPromotions(
        "select_promotion",
        target.parentNode.parentNode.parentNode
      );
    }

    if (target.classList.contains("linkDevo")) {
      const data = {
        content_type: "banner",
        item_list_name: "ver marcas"
      }
      GAHelpers.eventClickContent("select_content", data)
    }
  };


  if (window.location.pathname.includes("/")) {
    const data = {
      content: "homepage"
    }
    GAHelpers.eventClickContent("view_page", data)
  }
  /**
   * Events by URL
   */
  /**
   * Product page
   */
  if (window.location.pathname.includes("/products/")) {
    const handle = document
      .querySelector(".product-template-handle")
      .getAttribute("data-product-handle");

    if (handle) {
      const { product } = await GAHelpers.productByHandle(handle);
      if (window.location.search) {
        const variantId = window.location.search.replace("?variant=", "");
        const variant = GAHelpers.normalizeCurrentVariant(product, variantId);
        GAHelpers.eventProduct("view_item", variant);
      }
    }
  }
  /**
   * Collection page
   */
  if (window.location.pathname.includes("/collections/")) {
    var productsVariant = [];
    const productContainer = document.querySelectorAll(".hawk-product");

    const collectionName = document
      .querySelector("#pageHeading")
      .getAttribute("data-collection-title");
    const collectionSlug = collectionName
      .toLocaleLowerCase()
      .replace(/\s/g, "-");

    productContainer.forEach(async (item) => {
      const handle = item.getAttribute("data-product-handle");
      const index = item.getAttribute("data-ind");
      const { product } = await GAHelpers.productByHandle(handle);
      if (index) {
        product.index = index;
      }
      const variant = GAHelpers.normalizeCurrentVariant(product);
      productsVariant.push(variant);
    });

    setTimeout(() => {
      GAHelpers.eventCollection("view_item_list", null, productsVariant, {
        collectionHandle: collectionSlug,
        collection: collectionName,
      });
    }, 2500);
  }

  /**
   * Events on checkout process
   *
   */
  if (document.querySelector(".step")) {
    const step = document.querySelector(".step").getAttribute("data-step");
    const stepButton = document.querySelector(
      ".step .step__footer__continue-btn"
    );
    stepButton.classList.add(step);
    stepButton.addEventListener("click", () => {
      if (stepButton.classList.contains("contact_information")) {
        GAHelpers.eventProcessCheckout("add_shipping_info");
      }

      if (stepButton.classList.contains("shipping_method")) {
        GAHelpers.eventProcessCheckout("pre_order_confirmation");
      }

      if (stepButton.classList.contains("payment_method")) {
        GAHelpers.eventProcessCheckout("add_payment_info");
      }
    });

  }

  // Create an observer instance
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {

        isDesktop = GAHelpers.viewDevice();

        if (isDesktop) {
          if (entry.target.classList.contains("main__banner")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".main__banner--content"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("header-slider")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".carousel-cell"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-bottom")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".banner__beneficios_1"));
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".banner__beneficios_2"));
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".banner__beneficios_3"));
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("feature-banner")) {
            entry.target.querySelectorAll(".feature-banner").forEach(item => {
              GAHelpers.eventClickPromotions("view_promotion", item);
            })
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("timer-discount")) {
            entry.target.querySelectorAll(".timer-discount__item").forEach(item => {
              GAHelpers.eventClickPromotions("view_promotion", item);
            })
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("shop-by-category-featured")) {
            var productsVariant = [];
            entry.target.querySelectorAll(".rebuy-product-block .rebuy-product-title").forEach(async (item, index) => {
              item.setAttribute("data-index", index)
              const params = new URLSearchParams(item.getAttribute("href"));
              const handle = params.get('_rdiscovery-handle');
              const { product } = await GAHelpers.productByHandle(handle);
              const variant = GAHelpers.normalizeCurrentVariant(product);
              variant.index = item.getAttribute("data-index");
              productsVariant.push(variant);
            });
            observer.unobserve(entry.target);
            setTimeout(() => {
              GAHelpers.eventCollection("view_item_list", null, productsVariant, {
                collectionHandle: "Favoritos-de-la-cocina",
                collection: "Favoritos de la cocina",
              });
            }, 2000)
          }
          if (entry.target.classList.contains("tabs-carousel-container")) {
            observer.unobserve(entry.target);
            observer.disconnect();
          }

          if (entry.target.classList.contains("full-banner-countdown-section")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".block-banner"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-with-countdown")) {
            entry.target.querySelectorAll(".banner-images").forEach(item => {
              GAHelpers.eventClickPromotions("view_promotion", item);
            });
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-with-contdown-2")) {
            entry.target.querySelectorAll(".banner-images").forEach(item => {
              GAHelpers.eventClickPromotions("view_promotion", item);
            });
            observer.unobserve(entry.target);
          }

          //Alternate home
          if (entry.target.classList.contains("section-main-banner")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-1")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-2")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-3")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-4")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-5")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-6")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-7")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-8")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }


          if (entry.target.classList.contains("section_ofertas_flash")) {
            entry.target.querySelectorAll(".sectionImgsFlash .col div").forEach(item => {
              GAHelpers.eventClickPromotions("view_promotion", item);
              observer.unobserve(entry.target);
            })
          }

          if (entry.target.classList.contains("sectionBannersOfertas")) {
            entry.target.querySelectorAll(".itemBanner div").forEach(item => {
              GAHelpers.eventClickPromotions("view_promotion", item);
              observer.unobserve(entry.target);
            })
          }

          if (entry.target.classList.contains("sectionBannersAsados")) {
            entry.target.querySelectorAll(".itemBannerAsados div").forEach(item => {
              GAHelpers.eventClickPromotions("view_promotion", item);
              observer.unobserve(entry.target);
            })
          }

          if (entry.target.classList.contains("sectionBannersPublicidad")) {
            entry.target.querySelectorAll(".bannersPublicidad .col div").forEach(item => {
              GAHelpers.eventClickPromotions("view_promotion", item);
              observer.unobserve(entry.target);
            })
          }

          if (entry.target.classList.contains("featured-collection")) {
            var productsVariant = [];
            entry.target.querySelectorAll(".carousel-cell .card-product .link-item").forEach(async (item, index) => {
              const handle = item.getAttribute("data-handle");
              const { product } = await GAHelpers.productByHandle(handle);
              const variant = GAHelpers.normalizeCurrentVariant(product);
              variant.index = item.getAttribute("data-index");
              productsVariant.push(variant);
            });
            observer.unobserve(entry.target);
            setTimeout(() => {
              GAHelpers.eventCollection("view_item_list", null, productsVariant, {
                collectionHandle: "nuestros-favoritos",
                collection: "Nuestros favoritos",
              });
            }, 2000)
          }

        } else {
          if (entry.target.classList.contains("main__banner")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".main__banner--content"));
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("header-slider")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".carousel-cell"));
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("full-banner-countdown-section")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".block-banner"));
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("banner-bottom")) {
            let count = 0;
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".banner__beneficios_1"));
            const interval = setInterval(() => {
              GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector(".banner__info-item.is-selected"));
              count = count + 1;
              if (count >= 2) {
                clearInterval(interval);
                observer.unobserve(entry.target);
              }
            }, 5000);
          }

          if (entry.target.classList.contains("feature-banner-1")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("feature-banner-2")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("desktop_flash_1")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("desktop_flash_2")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("banner-with-countdown-alternate-1")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("banner-with-countdown-alternate-2")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("banner-with-contdown-two-alternate-1")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("banner-with-contdown-two-alternate-2")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }
          if (entry.target.classList.contains("shop-by-category-featured")) {
            var productsVariant = [];
            entry.target.querySelectorAll(".rebuy-product-block").forEach(async (item, index) => {
              if (item.classList.contains("is-selected")) {
                const productItem = item.querySelector(".rebuy-product-title");
                const params = new URLSearchParams(productItem.getAttribute("href"));
                const handle = params.get('_rdiscovery-handle');
                const { product } = await GAHelpers.productByHandle(handle);
                const variant = GAHelpers.normalizeCurrentVariant(product);
                variant.index = item.getAttribute("data-index");
                productsVariant.push(variant);
              }
            });
            observer.unobserve(entry.target);
            setTimeout(() => {
              GAHelpers.eventCollection("view_item_list", null, productsVariant, {
                collectionHandle: "Favoritos-de-la-cocina",
                collection: "Favoritos de la cocina",
              });
            }, 2000)
          }
          //Alternate home

          if (entry.target.classList.contains("section-main-banner")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-1")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-2")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-3")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-4")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-5")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-6")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-7")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("cyber-collection-item-8")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.parentNode);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("section-image-flash-1")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector("div"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("section-image-flash-2")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector("div"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-ofertas-1")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector("div"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-ofertas-2")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector("div"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-ofertas-3")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector("div"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-ofertas-4")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector("div"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-asados-1")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector("div"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-asados-2")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector("div"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-asados-3")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector("div"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("banner-asados-4")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target.querySelector("div"));
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("section-banner-publicidad-1")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("section-banner-publicidad-2")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("section-banner-publicidad-3")) {
            GAHelpers.eventClickPromotions("view_promotion", entry.target);
            observer.unobserve(entry.target);
          }

          if (entry.target.classList.contains("featured-collection")) {
            var productsVariant = [];
            entry.target.querySelectorAll(".carousel-cell .card-product .link-item").forEach(async (item, index) => {
              const handle = item.getAttribute("data-handle");
              const { product } = await GAHelpers.productByHandle(handle);
              const variant = GAHelpers.normalizeCurrentVariant(product);
              variant.index = item.getAttribute("data-index");
              productsVariant.push(variant);
            });
            observer.unobserve(entry.target);
            setTimeout(() => {
              GAHelpers.eventCollection("view_item_list", null, productsVariant, {
                collectionHandle: "nuestros-favoritos",
                collection: "Nuestros favoritos",
              });
            }, 2000)
          }

        }
      }
    });
  });

  const sections = document.querySelectorAll("section");
  const featureBanner1 = document.querySelector(".feature-banner-1");
  const featureBanner2 = document.querySelector(".feature-banner-2");
  const timeDiscountItemDesktop1 = document.querySelectorAll(".desktop_flash_1");
  const timeDiscountItemDesktop2 = document.querySelectorAll(".desktop_flash_2");
  const bannerCountDownAlternate1 = document.querySelectorAll(".banner-with-countdown-alternate-1");
  const bannerCountDownAlternate2 = document.querySelectorAll(".banner-with-countdown-alternate-2");
  const bannerCountDownAlternateTwo1 = document.querySelectorAll(".banner-with-contdown-two-alternate-1");
  const bannerCountDownAlternateTwo2 = document.querySelectorAll(".banner-with-contdown-two-alternate-2");

  const cyberCollection1 = document.querySelector(".cyber-collection-item-1");
  const cyberCollection2 = document.querySelector(".cyber-collection-item-2");
  const cyberCollection3 = document.querySelector(".cyber-collection-item-3");
  const cyberCollection4 = document.querySelector(".cyber-collection-item-4");
  const cyberCollection5 = document.querySelector(".cyber-collection-item-5");
  const cyberCollection6 = document.querySelector(".cyber-collection-item-6");
  const cyberCollection7 = document.querySelector(".cyber-collection-item-7");
  const cyberCollection8 = document.querySelector(".cyber-collection-item-8");

  observer.observe(cyberCollection1)
  observer.observe(cyberCollection2)
  observer.observe(cyberCollection3)
  observer.observe(cyberCollection4)
  observer.observe(cyberCollection5)
  observer.observe(cyberCollection6)
  observer.observe(cyberCollection7)
  observer.observe(cyberCollection8)



  const ofertaFlashImage1 = document.querySelector(".section-image-flash-1");
  const ofertaFlashImage2 = document.querySelector(".section-image-flash-2");

  const bannerOfertas1 = document.querySelector(".banner-ofertas-1");
  const bannerOfertas2 = document.querySelector(".banner-ofertas-2");
  const bannerOfertas3 = document.querySelector(".banner-ofertas-3");
  const bannerOfertas4 = document.querySelector(".banner-ofertas-4");

  const bannerAsados1 = document.querySelector(".banner-asados-1");
  const bannerAsados2 = document.querySelector(".banner-asados-2");
  const bannerAsados3 = document.querySelector(".banner-asados-3");
  const bannerAsados4 = document.querySelector(".banner-asados-4");

  const bannerPublicidad1 = document.querySelector(".section-banner-publicidad-1");
  const bannerPublicidad2 = document.querySelector(".section-banner-publicidad-2");
  const bannerPublicidad3 = document.querySelector(".section-banner-publicidad-3");

  observer.observe(ofertaFlashImage1)
  observer.observe(ofertaFlashImage2)

  observer.observe(bannerOfertas1)
  observer.observe(bannerOfertas2)
  observer.observe(bannerOfertas3)
  observer.observe(bannerOfertas4)

  observer.observe(bannerAsados1)
  observer.observe(bannerAsados2)
  observer.observe(bannerAsados3)
  observer.observe(bannerAsados4)

  observer.observe(bannerPublicidad1)
  observer.observe(bannerPublicidad2)
  observer.observe(bannerPublicidad3)


  sections.forEach((section) => {
    observer.observe(section);
  });

  timeDiscountItemDesktop1.forEach((flash) => {
    observer.observe(flash);
  });

  timeDiscountItemDesktop2.forEach((flash) => {
    observer.observe(flash);
  });

  bannerCountDownAlternate1.forEach((item) => {
    observer.observe(item);
  });

  bannerCountDownAlternate2.forEach((item) => {
    observer.observe(item);
  });

  bannerCountDownAlternateTwo1.forEach((item) => {
    observer.observe(item);
  });

  bannerCountDownAlternateTwo2.forEach((item) => {
    observer.observe(item);
  });

  observer.observe(featureBanner1)
  observer.observe(featureBanner2)

  //Alternate homepage




});

